import { useMemo, useRef, useState } from "react";
import useNetwork from "../common/hooks/networkHook";
import { FormDialog } from "../common/components/CustomForm";
import { matchComment, useAllRequiredComments } from "../reducers/requiredCommentSlice";
import { ensureArray } from "../common/utils/arrayUtilities";

const requiredComment2CustomForm = data => ([{ borderless: true, rows: ensureArray(data.fields).map(f => {
    const row = [{ type: "label", text: f.label, colspan: 6 }]
    if (f.values) {
        row.push({ type: "option", field: f.placeholder, label: ' ', required: f.required, options: f.values, colspan: 6 })
    } else {
        row.push({ type: "text", field: f.placeholder, label: ' ', required: f.required, colspan: 6 })
    }
    return row;
}) }]);

export const useJobRequiredComment = () => {
    const network = useNetwork();
    const [pendingOperation, setPendingOperation] = useState();
    const [requiredComment, setRequiredComment] = useState();
    const requiredComments = useAllRequiredComments();
    const callback = useRef();

    
    return useMemo(() => ({
        processRequiredComment: async (job, event, operation, delta, onComplete) => {
            const data = requiredComments.filter(comment => matchComment(comment, job.site, job.level, job.type, job.problem, event)).filter(comment => comment.required);
            if (!data || data.length === 0) {
                onComplete(operation(network, delta));
            } else {
                setPendingOperation({ operation, delta, ops: data.slice(1) });
                setRequiredComment({ id: data[0].id, form: data[0].form ?? requiredComment2CustomForm(data[0]) });
                callback.current = onComplete;
            }
        },
        requiredCommentModal: () => {
            const values = {}
            const def = requiredComment?.form;
            return def ? <FormDialog def={def} showModal={true} values={values} title="Additional Required Details" prohibitCancel={true} size="lg" onClose={delta => {
                if (delta || !requiredComment.fields || requiredComment.fields.length < 1) {
                    network.post('/api/v1/jobComment', { jobid: pendingOperation.delta.jobid, commentid: requiredComment.id, values: (delta ?? {}) })
                    if (pendingOperation.data?.length > 0) {
                        const op = pendingOperation.ops[0];
                        setRequiredComment({ id: op.id, form: op.form ?? requiredComment2CustomForm(op) });
                        setPendingOperation(op => ({ ...op, ops: op.ops.slice(1) }));
                    } else {
                        const result = pendingOperation.operation(network, pendingOperation.delta);
                        callback.current?.(result);
                        callback.current = null;
                        setRequiredComment();
                        setPendingOperation();
                    }
                }
            }} ></FormDialog> : null;
        }
    }), [pendingOperation, requiredComment, network, requiredComments]);
}